__turbopack_context__.v({
  "item": "ReportBlockExportMenu-module__1YEVra__item",
  "menu": "ReportBlockExportMenu-module__1YEVra__menu",
  "trigger": "ReportBlockExportMenu-module__1YEVra__trigger",
});
